var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape_2",
    d: "M21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42ZM16.3266 11.8921L25.4345 21L16.3266 30.1079C15.5578 30.8767 15.5578 32.1233 16.3266 32.8921C17.0955 33.661 18.342 33.661 19.1109 32.8921L29.6109 22.3921C30.3797 21.6233 30.3797 20.3767 29.6109 19.6079L19.1109 9.10788C18.342 8.33904 17.0955 8.33904 16.3266 9.10788C15.5578 9.87673 15.5578 11.1233 16.3266 11.8921Z",
    fill: "#94A4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow3.5f6b86d171cd14220429742e5ee436dd.svg";
export { ForwardRef as ReactComponent };